<template>
    <div>Uploader</div>
</template>
<script lang="ts" setup>
/**
 * Shows a file dropdown for uploading files and will try and automatically find what kind of file it is and return the potential importers.
 *
 */

const props = defineProps<{
    /**
     * The description file to show
     */
    text: string;
}>();
</script>
